export default __webpack_public_path__ + "static/media/resume.5ce014dc.png";